import { FC, SVGProps } from 'react';

export const DesktopIcon: FC<SVGProps<SVGSVGElement>> = props => (
	<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32" fill="none" {...props}>
		<path
			fillRule="evenodd"
			clipRule="evenodd"
			d="M3.25 7C3.25 6.0335 4.0335 5.25 5 5.25H27C27.9665 5.25 28.75 6.0335 28.75 7V19C28.75 19.9665 27.9665 20.75 27 20.75H16.95C16.8395 20.75 16.75 20.8395 16.75 20.95V24.55C16.75 24.6605 16.8395 24.75 16.95 24.75H21.5C21.9142 24.75 22.25 25.0858 22.25 25.5C22.25 25.9142 21.9142 26.25 21.5 26.25H10.5C10.0858 26.25 9.75 25.9142 9.75 25.5C9.75 25.0858 10.0858 24.75 10.5 24.75H15.05C15.1605 24.75 15.25 24.6605 15.25 24.55V20.95C15.25 20.8395 15.1605 20.75 15.05 20.75H5C4.0335 20.75 3.25 19.9665 3.25 19V7ZM5 6.75C4.86193 6.75 4.75 6.86193 4.75 7V19C4.75 19.1381 4.86193 19.25 5 19.25H27C27.1381 19.25 27.25 19.1381 27.25 19V7C27.25 6.86193 27.1381 6.75 27 6.75H5Z"
			fill="currentColor"
		/>
	</svg>
);
